import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Card} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import {useNavigate} from 'react-router'
import Logo from '../../ui/logos/Logo';

export const UpdatePasswordInformation = () => {
    const navigate = useNavigate();

    return (
        <Container fluid>
            <Row style={{height: '100vh'}} className={'align-items-center'}>
                <Col xs={12} md={4} className={'mx-auto'}>
                    <Row className={'mb-2'}>
                        <Col className={'text-center'}>
                            <Logo widthClass={'w-50'} />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Header className={'bg-primary border-0 text-white font-weight-bold'} style={{fontSize: '15px'}}>
                                    Information importante
                                </Card.Header>
                                <Card.Body className={'text-justify'}>
                                    Un email vient d'être envoyé à votre adresse ({sessionStorage.getItem('email')}) pour procéder à la modification de votre mot de passe.
                                    <br/><br/>
                                    Ce message contient un lien sécurisé permettant d'accéder à l'interface de réinitialisation. Pour des raisons de sécurité, ce lien est valable pendant <b><u>un délai de 24 heures</u></b> à compter de sa réception.
                                    <br/><br/>
                                    Si vous ne recevez pas cet email, pensez à vérifier votre dossier spam ou courriers indésirables, ou contactez <a href={'mailto:reseau@florajet.com'}><b>notre support</b></a>.
                                </Card.Body>
                                <Card.Footer className={'border-0 bg-white'}>
                                    <Button variant={'secondary'} onClick={() => navigate('/')}><FontAwesomeIcon icon={faArrowLeft} className={'mr-2'} />Retour</Button>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}
